// Ward-missionary matching — shared by the web ward app and the iOS ward
// screens so the two never drift. A missionary record stores its home ward as
// the ward org's display name (the stake's missionary editor builds that
// dropdown from the org list's `name`); legacy/seed data may store the name
// without a trailing " Ward", and some data stores the subdomain code instead.
// This resolves all three against the active ward org.

/** Minimal shape of the ward org we match against. */
export interface WardOrgRef {
  name?: string | null
  subdomain?: string | null
}

// Lowercase, trim, drop a trailing " Ward" — so "Driggs 1st Ward",
// "driggs 1st", and " Driggs 1st " all collapse to "driggs 1st".
function normWardName(s: string | null | undefined): string {
  return (s || '').trim().toLowerCase().replace(/\s+ward$/, '')
}

/**
 * Does a missionary (by its `ward` value) belong to the given ward org? Matches
 * case-insensitive subdomain equality OR normalized-name equality.
 */
export function isMissionaryInWard(
  missionaryWard: string | null | undefined,
  org: WardOrgRef | null | undefined,
): boolean {
  const mw = (missionaryWard || '').trim().toLowerCase()
  if (!mw || !org) return false
  const sub = (org.subdomain || '').trim().toLowerCase()
  if (sub && mw === sub) return true
  const n = normWardName(org.name)
  return !!n && normWardName(missionaryWard) === n
}
